import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './tokens/index.css'
import './styles/base.css'
import App from './App'
import { AuthProvider, getToken } from './auth'
import { configureApi } from './api'

/* THE SEAM between auth and the API client, wired here and nowhere else.
   `getToken()` returns a live Cardea access token, refreshing first if it is
   expired or inside the refresh margin, and `null` when there is no session;
   `api.ts` awaits it immediately before building each request. Neither module
   imports the other — they meet at this one call, which is why they could be
   built in parallel.

   VITE_DEV_TOKEN overrides it with a static bearer token, so the data screens
   can be driven against a local backend without completing a real sign-in. Like
   VITE_DEV_USER it is read only under import.meta.env.DEV and cannot reach a
   production build. */
const devToken = import.meta.env.DEV
  ? (import.meta.env.VITE_DEV_TOKEN as string | undefined)
  : undefined

configureApi({ getToken: devToken ? () => devToken : getToken })

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

/* AuthProvider wraps App rather than living inside it so that `useAuth()` works
   from any screen — Settings' sign-out is the first caller — without threading
   the session down through Shell. */
createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
)
